import { AbstractAccessorService, IDataAccessor } from "@core/data-access";
import { IResponse } from "@core/data-access/model";
import { IViewDesignMethods } from "../model/domain/viewDesignMethods";
import { IViewDesignMethodsRestService } from "./view-design-methods-rest";
import { IViewDesignMethodsDto } from "../model/dto/viewDesignMethodsDto";

export class ViewDesignMethodsRestService extends AbstractAccessorService<IViewDesignMethods> implements IViewDesignMethodsRestService {
    public $name: string = "viewDesignMethodsRestService";
    public static readonly $inject: string[] = ["$accessor"];
    constructor(public $accessor: IDataAccessor<IViewDesignMethods>) {
        super();
    }
    saveDesignMethods(data: IViewDesignMethodsDto, parameters: { id: string } ): angular.IPromise<IResponse<boolean>> {
        return this.$accessor<boolean, IViewDesignMethodsDto, { id: string }, 'saveDesignMethods'>(this.$name, "saveDesignMethods", {
            data:data,
            parameter: parameters
        })
    }
}